module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Export":"Exporter en Excel","Title":"Rapport de vélocité de "}}')
  delete Component.options._Ctor
}
